import React from 'react';
import { observer } from 'mobx-react';
import { CardMainLayout, Catcher, cardLayoutOptions } from '../../index';
import { useMonthlyRecurringChargesList } from '../../../hooks';
import { tP } from '../../../translate';
import Styles from '../../styles/m_itemCardStyles.less';

export const ShowRateMrcNrco: React.FC = observer(() => {
    const monthlyRecurringChargesList = useMonthlyRecurringChargesList();

    const defaultValues = monthlyRecurringChargesList?.filter((value) => value.chargeType) || [];
    const customValues = monthlyRecurringChargesList?.filter((value) => !value.chargeType) || [];

    const resultingArr = [...defaultValues, ...customValues];

    return (
        <Catcher>
            <CardMainLayout
                idSpinners={['GET_COMPANY_MONTHLY_PAYMENTS', 'GET_COMPANY']}
                name={tP('Monthly Recurring Costs')}
                columnOption={cardLayoutOptions.mrcForm}
            >
                {resultingArr.length ? (
                    <div className={Styles.mrcFormItem}>
                        {resultingArr.map((value) => {
                            const isDefault = value.chargeType === undefined;
                            const isPerImsi = value.chargeType === 'imsi';

                            return (
                                <div className={Styles.mrcFormItemContainer} key={value.id}>
                                    {!isDefault ? (
                                        <div className={Styles.mrcFormItemDefaultHeader}>
                                            <span>{isPerImsi ? 'Per Imsi' : 'Per Card'}:</span>
                                            <div>
                                                {value.name === 'all'
                                                    ? 'All'
                                                    : value.name === 'active_cdr' && isPerImsi
                                                    ? 'Active this month'
                                                    : 'Active'}
                                            </div>
                                        </div>
                                    ) : (
                                        <span>{value.name}</span>
                                    )}
                                    <div style={{ color: 'green' }}>EUR {value.amountCents}</div>
                                </div>
                            );
                        })}
                    </div>
                ) : (
                    <div className={Styles.mrcFormEmptyContainer}>
                        <p className={Styles.mrcFormEmptyText}>No Recurring Costs Yet</p>
                    </div>
                )}
            </CardMainLayout>
        </Catcher>
    );
});
